// ═══════════════════════════════════════════════
//   MISSIONS — list + claim, fetched from Supabase
// ═══════════════════════════════════════════════

const {S, DB, addPts, toast, scheduleSave} = window;

// ══════════════════════════════════════════
// MISSIONS — loaded live from Supabase
// To change missions: go to Supabase dashboard
//   → Table Editor → missions table
//   Edit title, description, pts, active_date, trigger_key…
//
// Two kinds of rows:
//   • Link missions (trigger_key = NULL)  — open the link → claim.
//   • Trigger missions (trigger_key set)  — auto-complete when the matching
//     in-app event fires; the row shows a "Go →" shortcut to the window.
// ══════════════════════════════════════════

// Each trigger_key maps to the window the user should head to in order to
// complete the mission. Used for the "Go →" button on trigger rows.
const MISSION_TRIGGER_WIN = {
    edit_profile:        'w-profile',
    read_bio:            'w-about',
    feed_alien:          'w-tama',
    shop_buy:            'w-shop',
    'play_game:workers': 'w-games',
    'play_game:shooter': 'w-games',
    'play_game:restock': 'w-games',
    gacha_roll:          'w-gacha',
    new_alien:           'w-gacha',
    new_bunny:           'w-gacha',
    mail_reply:          'w-konmail',
    spam_reply:          'w-konmail',
    staff_hire:          'w-staff',
    cameras_open:        'w-cam',
    beat_record:         'w-games',
    logbook_fav:         'w-logbook',
    profile_png_save:    'w-profile',
};

async function fetchAndRenderMissions() {
    try {
        const {data, error} = await DB.fetchMissions();
        if (error) throw error;
        S.missionsData = data || [];
    } catch (e) {
        console.warn('Could not load missions:', e);
        S.missionsData = [];
    }
    _autoCompleteSatisfiedMissions();
    renderMissionsList();
}

// Auto-complete trigger missions whose target state is already satisfied —
// so collectors who already own every alien / bunny don't get a mission they
// physically can't progress (a non-duplicate pull is impossible at 100%).
function _autoCompleteSatisfiedMissions() {
    if (!S.missionsData.length) return;
    const GACHA_POOL = window.GACHA_POOL || [];
    const allAlienIds   = GACHA_POOL.filter(e => e.type === 'alien').map(e => e.id);
    const allBunnyIds   = GACHA_POOL.filter(e => e.type === 'bunnymeal').map(e => e.id);
    const ownedAlienIds = new Set((S.myAliens || []).map(a => a.alienId));
    const ownedBunnyIds = new Set((S.myBunnymeals || []).map(b => b.id));
    const hasAllAliens  = allAlienIds.length > 0 && allAlienIds.every(id => ownedAlienIds.has(id));
    const hasAllBunnies = allBunnyIds.length > 0 && allBunnyIds.every(id => ownedBunnyIds.has(id));
    if (hasAllAliens)  window.triggerMission('new_alien');
    if (hasAllBunnies) window.triggerMission('new_bunny');
}

function renderMissionsList() {
    const container = document.getElementById('mission-list-dynamic');
    if (!container) return;
    if (!S.missionsData.length) {
        container.innerHTML = '<div style="font-family:\'Press Start 2P\',monospace;font-size:6px;color:#aaa;padding:8px;">No missions right now — check back later! ✦</div>';
        return;
    }
    const BTN = 'font-family:\'Press Start 2P\',monospace;font-size:5.5px;border:2px solid var(--dark);border-radius:8px;padding:3px 8px;cursor:pointer;';
    container.innerHTML = S.missionsData.map(m => {
        const done = S.completedMissions.includes(m.id);
        const isTrigger = !!m.trigger_key;
        let actionHTML;
        if (done) {
            actionHTML = `<span style="${BTN}background:#d1fae5;color:#166534;cursor:default;">✓ Done! +${m.pts}pts</span>`;
        } else if (isTrigger) {
            const winId = MISSION_TRIGGER_WIN[m.trigger_key] || '';
            const goBtn = winId
                ? `<button onclick="window.openWin('${winId}')" style="${BTN}background:var(--pink);color:white;">Go →</button>`
                : '';
            actionHTML = `${goBtn}<span style="${BTN}background:#fef3c7;color:#92400e;cursor:default;">Auto · +${m.pts}pts</span>`;
        } else {
            const url   = (m.link_url   || '').replace(/'/g, "\\'");
            const label = (m.link_label || 'Open Link').replace(/'/g, "\\'");
            // Persisted link-opened state — when the user comes back after a
            // reload we still want the Claim button visible so they can finish.
            const opened = !!S.missionLinkOpened[m.id];
            const linkBtnLabel = opened ? '↗ Opened!' : (m.link_label || 'Open Link');
            actionHTML = `<button id="ml-${m.id}" onclick="missionOpenLink(${m.id},'${url}','${label}')" style="${BTN}background:var(--pink);color:white;">${linkBtnLabel}</button>
              <button id="mclaim-${m.id}" onclick="claimMission(${m.id})" style="${BTN}background:var(--lime);color:var(--dark);display:${opened ? 'inline-block' : 'none'};">✓ Done! +${m.pts}pts</button>`;
        }
        return `<div class="mission-item${done ? ' done' : ''}" id="mi-${m.id}">
      <div class="m-check${done ? ' done' : ''}" id="mc-${m.id}">${done ? '✓' : ''}</div>
      <div style="flex:1;">
        <div style="font-family:'Press Start 2P',monospace;font-size:6.5px;color:var(--dark);line-height:1.8;">${m.title}</div>
        ${m.description ? `<div style="font-family:'Nunito',sans-serif;font-size:10px;color:#999;margin-top:1px;">${m.description}</div>` : ''}
        <div style="margin-top:6px;display:flex;gap:5px;flex-wrap:wrap;align-items:center;">${actionHTML}</div>
      </div>
    </div>`;
    }).join('');
}

function missionOpenLink(id, url, label) {
    window.open(url, '_blank');
    S.missionLinkOpened[id] = true;
    scheduleSave();
    _recordMissionEventRemote(id, 'link_opened');
    const linkBtn = document.getElementById('ml-' + id);
    const claimBtn = document.getElementById('mclaim-' + id);
    if (linkBtn) linkBtn.textContent = '↗ Opened!';
    if (claimBtn) claimBtn.style.display = 'inline-block';
}

function _recordMissionEventRemote(missionKey, eventType) {
    if (!window.DB || !window.DB.available()) return;
    // safeCall awaits the thenable; without that, the supabase-js builder
    // is constructed but the HTTP request is never dispatched.
    window.safeCall('recordMissionEvent',
        () => window.DB.recordMissionEvent(missionKey, eventType),
        { toast: false });
}

function claimMission(id) {
    if (!S.missionLinkOpened[id]) {
        toast('Open the link first! 👀');
        return;
    }
    if (S.completedMissions.includes(id)) return;
    const m = S.missionsData.find(x => x.id === id);
    if (!m) return;
    S.completedMissions.push(id);
    _recordMissionEventRemote(id, 'completed');
    const reward = m.pts || 20;
    addPts(reward, `mission:${id}`);
    toast(`+${reward} pts for completing the mission! ✦`);
    // Update DOM
    const item = document.getElementById('mi-' + id);
    if (item) item.classList.add('done');
    const cb = document.getElementById('mc-' + id);
    if (cb) {
        cb.classList.add('done');
        cb.textContent = '✓';
    }
    const claimBtn = document.getElementById('mclaim-' + id);
    if (claimBtn) {
        claimBtn.style.display = 'none';
    }
    const linkBtn = document.getElementById('ml-' + id);
    if (linkBtn) {
        linkBtn.textContent = `✓ Done! +${reward}pts`;
        linkBtn.disabled = true;
        linkBtn.style.background = '#d1fae5';
        linkBtn.style.color = '#166534';
    }
    // VIP if all active missions done
    if (S.missionsData.every(x => S.completedMissions.includes(x.id))) window.unlockNick('vip');
    scheduleSave();
}

window.fetchAndRenderMissions = fetchAndRenderMissions;
window.renderMissionsList = renderMissionsList;
window.missionOpenLink = missionOpenLink;
window.claimMission = claimMission;
